import type { WorkOrderStatus, WorkOrderWithAppointments } from "@myapp/contract";

export const isFollowUpRequired = (status: WorkOrderStatus): boolean =>
  status === "FOLLOW_UP_REQUIRED_1" || status === "FOLLOW_UP_REQUIRED_2";

/**
 * A work order takes another Termin when it is a Wohnungsmodernisierung (many visits by design),
 * when a Folgetermin is owed, or when it has no appointment at all yet.
 *
 * Shared so the list row's quick-plan action and the detail page's header actions can never
 * disagree about the same Auftrag.
 */
export const isNewAppointmentAllowed = (workOrder: WorkOrderWithAppointments): boolean =>
  workOrder.external.isWohnungsmodernisierung ||
  isFollowUpRequired(workOrder.status) ||
  workOrder.appointments.length === 0;
